// extracted by mini-css-extract-plugin
module.exports = {"icon":"#4a73e8","close":"#95979d"};